export var GIFT_CARD = {
  'fr-FR': {
    eGift: 'e-carte-cadeau-maisons-du-monde',
    giftCard: '/fr/carte-cadeau',
    giftCardMDMUrl: '/FR/fr/e/cartes-cadeaux-maisons-du-monde',
    isOpen: true
  },
  'nl-BE': {
    eGift: 'digitale-cadeaukaart-maisons-du-monde',
    giftCard: '/nl/cadeaukaarten',
    giftCardMDMUrl: '/BE/nl/e/cadeaukaarten-maisons-du-monde',
    isOpen: true
  },
  'fr-BE': {
    eGift: 'e-carte-cadeau-maisons-du-monde',
    giftCard: '/fr/carte-cadeau',
    giftCardMDMUrl: '/BE/fr/e/cartes-cadeaux-maisons-du-monde',
    isOpen: true
  },
  'de-DE': {
    eGift: 'geschenkkarte-maisons-du-monde',
    giftCard: '/de/geschenkkarte',
    giftCardMDMUrl: '/DE/de/e/maisons-du-monde-geschenkkarten',
    isOpen: true
  },
  'es-ES': {
    eGift: 'tarjeta-regalo-electronica-maisons-du-monde',
    giftCard: '/es/tarjeta-regalo',
    giftCardMDMUrl: '/ES/es/e/tarjetas-regalo-maisons-du-monde',
    isOpen: true
  },
  'it-IT': {
    eGift: 'carta-regalo-digitale-maisons-du-monde',
    giftCard: '/it/gift-card',
    giftCardMDMUrl: '/IT/it/e/carte-regalo-maisons-du-monde',
    isOpen: true
  },
  'fr-LU': {
    eGift: 'e-carte-cadeau-maisons-du-monde',
    giftCard: '/fr/carte-cadeau',
    giftCardMDMUrl: '/LU/fr/e/cartes-cadeaux-maisons-du-monde',
    isOpen: true
  },
  'nl-NL': {
    eGift: 'digitale-cadeaukaart-maisons-du-monde',
    giftCard: '/nl/cadeaukaarten',
    giftCardMDMUrl: '/NL/nl/e/cadeaukaarten-maisons-du-monde',
    isOpen: true
  },
  'pt-PT': {
    eGift: 'cartao-presente-eletronico-maisons-du-monde',
    giftCard: '/PT/pt/cartão-presente',
    giftCardMDMUrl: '/PT/pt/e/cartão-presente-maisons-du-monde',
    isOpen: false
  },
  'de-CH': {
    eGift: 'geschenk-karte-maisons-du-monde',
    giftCard: '/de/geschenkkarte',
    giftCardMDMUrl: '/CH/de/e/geschenk-karte-von-maisons-du-monde',
    isOpen: false
  },
  'it-CH': {
    eGift: 'carta-regalo-digitale-maisons-du-monde',
    giftCard: '/it/gift-card',
    giftCardMDMUrl: '/CH/it/e/carte-regalo-maisons-du-monde',
    isOpen: false
  },
  'fr-CH': {
    eGift: 'e-carte-cadeau-maisons-du-monde',
    giftCard: '/fr/carte-cadeau',
    giftCardMDMUrl: '/CH/fr/e/cartes-cadeaux-maisons-du-monde',
    isOpen: false
  },
  'en-GB': {
    eGift: 'online-gift-card-maisons-du-monde',
    giftCard: '/en/gift-card',
    giftCardMDMUrl: '/GB/en/e/gift-cards-maisons-du-monde',
    isOpen: false
  }
};
export var GIFT_CARD_THEMES = {
  DEFAULT: 'default'
};
export var getGiftCardImages = function getGiftCardImages(theme, locale) {
  var baseURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'https://medias.maisonsdumonde.com/image/upload/medias/services/gift-card/theme-';
  return {
    packshot1: "".concat(baseURL).concat(theme).concat(locale, "-packshot-1.svg"),
    packshot2: "".concat(baseURL).concat(theme).concat(locale, "-packshot-2.svg")
  };
};